export default {
  CLOSED_BY_USER: 'closed-by-user',
  SUCCEED: 'succeed',
};



// WEBPACK FOOTER //
// ./src/full-screen-modals/constants/close-reasons.js